import { render, staticRenderFns } from "./BenefitBertPoints.vue?vue&type=template&id=ee6c2cdc&scoped=true"
import script from "./BenefitBertPoints.vue?vue&type=script&lang=js"
export * from "./BenefitBertPoints.vue?vue&type=script&lang=js"
import style0 from "./BenefitBertPoints.vue?vue&type=style&index=0&id=ee6c2cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6c2cdc",
  null
  
)

export default component.exports